export enum InvoiceFundingType {
  //All,
  FundingType_Internal = 0,
  FundingType_External = 1,
}
